import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { usePromo } from "../Context/PromoContext";
import axios from "axios";

export default function PromoSaleCountDown() {
  const location = useLocation();
  const isBrowser = typeof window !== "undefined";
  const { promoMessages } = usePromo();

  const [showPromoMessage, setShowPromoMessage] = useState(
    typeof window !== "undefined" ? window.innerWidth > 767 : true
  );
  const [isVisible, setIsVisible] = useState(false);
  const [promoText, setPromoText] = useState("");
  const [promoSaleTitle, setPromoSaleTitle] = useState("");
  const [promoExists, setPromoExists] = useState(false);

  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [isActivePromo, setIsActivePromo] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isBrowser) return;

    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isBrowser) return;

    const update = () => {
      setShowPromoMessage(window.innerWidth > 767);
    };

    update();

    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  useEffect(() => {
    if (!isBrowser) return;

    const el = document.querySelector(".bottom-footer");
    if (!el) return;

    el.style.marginBottom = promoExists ? "90px" : "";
  }, [promoExists]);

  const startCountdown = (endDate) => {
    if (!isBrowser) return;

    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      const now = new Date().getTime();
      const diff = endDate.getTime() - now;

      if (diff <= 0) {
        clearInterval(intervalRef.current);
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setCountdown({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60)
      });
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (!isBrowser) return;

    setIsActivePromo(false);
    setPromoExists(false);

    const currentPage = location.pathname.replace(/^\/|\/$/g, "");

    const matched = promoMessages.find(
      (item) =>
        item.pageName.trim() === currentPage.trim() &&
        item.isActive === true
    );

    if (!matched) return;

    const discountMatch = matched.promoMessage.match(/(\d+)%/);
    const discount = discountMatch ? discountMatch[0] : "";

    setPromoText(`Grab ${discount} off`);

    const now = new Date();
    const startDate = new Date(matched.startDate);
    const endDate = new Date(matched.endDate);

    if (now < startDate || now > endDate) return;

    setIsActivePromo(true);
    setPromoExists(true);
    startCountdown(endDate);
  }, [promoMessages, location.pathname]);

  useEffect(() => {
    if (!isBrowser) return;

    const fetchPromoSaleTitle = async () => {
      try {
        const res = await axios.get(
          `${import.meta.env.VITE_BACKEND_API_URL}/admin/get-web-promo-sale-title`
        );

        if (res.data.success) {
          setPromoSaleTitle(res.data.data.name || "Sale");
        }
      } catch {}
    };

    fetchPromoSaleTitle();
  }, [location.pathname]);

  const formatTwoDigits = (n) => String(n).padStart(2, "0");

  if (!isActivePromo) return null;

  return (
    <>
      {showPromoMessage && (
        <div className={`promo-sale-container ${isVisible ? "visible" : ""}`}>
          <div className="sale-title">
            <span className="miss-out-text">Don't miss out</span>
            <h2>
              {promoSaleTitle} <span className="badge">Sale</span>
            </h2>
          </div>

          <div className="countdown-timer">
            <div className="timer">
              <div className="time-part">
                <span className="number">{formatTwoDigits(countdown.days)}</span>
                <p>Days</p>
              </div>

              <div className="colon">:</div>

              <div className="time-part">
                <span className="number">{formatTwoDigits(countdown.hours)}</span>
                <p>Hours</p>
              </div>

              <div className="colon">:</div>

              <div className="time-part">
                <span className="number">{formatTwoDigits(countdown.minutes)}</span>
                <p>Minutes</p>
              </div>

              <div className="colon">:</div>

              <div className="time-part">
                <span className="number">{formatTwoDigits(countdown.seconds)}</span>
                <p>Seconds</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}